import React, { useEffect, useState } from "react"
import { signin, signup } from "../functions/authentication"

const width = window.innerWidth
const height = window.innerHeight
const styles = {
    headText: {
        fontSize: 40,
        fontWeight: "bold",
        color: "red",
        margin: "0px 20px"
    },
    subTexts: {
        fontSize: 17,
        // textAlign: "center",
        color: "#FFF",
        margin: "0px 20px"
    },
    titlesWrapper: {
        margin: "20px 0 0 0",
    },
    input: {
        margin: "10px 15px",
        borderRadius: 10,
        backgroundColor: "rgb(250,250,250)",
        // height: 50,
        padding: "12px 15px",
        fontSize: 17,
        borderWidth: 3,
        width: width - 60,
        outline: "none",
        border: "none"
    },
    forgotPassword: {
        alignSelf: "flex-end",
        margin: 15
    },
    forgotPasswordText: {
        fontSize: 15,
        color: "#FFF"
    },
    buttons: {
        // position: "absolute",
        // bottom: 0,
        width,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: 15
    },
    buttonWrapper: {
        // height: 50,
        padding: "15px 0",
        width: width - 30,
        borderRadius: 50,
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "5px 10px 15px 10px"
    },
    buttonText: {
        color: "red",
        fontSize: 16,
        fontWeight: "bold"
    },
    loaderView: {
        position: "absolute",
        width,
        height,
        top: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}

export default function SignUp() {

    const [signingUp, setSignUp] = useState(false)

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [fullnames, setFullNames] = useState("")
    const [phone, setPhone] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [address, setAddress] = useState("")

    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState(null)

    useEffect(() => {

        setTimeout(() => {
            setErrors(null)
        }, 5000)

        return () => clearTimeout()

    }, [errors])

    const signingIn = async () => {
        
        setLoading(true)
        let result = await signin(email, password)
        setErrors(result)
        setLoading(false)

    }

    const signinup = async () => {
        
        setLoading(true)
        let result = await signup(email, password, fullnames, phone, idNumber, address)
        setErrors(result)
        setLoading(false)

    }

    return (
        <>
            <div style={{ width, height, backgroundColor: "#141414" }}>
                <div style={{ width, height, overflowY: "auto" }}>
                    <div style={styles.titlesWrapper}> 
                        <p style={styles.headText}>Signing In</p> 
                    </div>
                    {
                        !signingUp ?
                            <p style={{ ...styles.subTexts, marginBottom: 15 }}>
                                Please Log In To Your Account
                            </p> : 
                            <p style={{ ...styles.subTexts, marginBottom: 15 }}>
                                Creating your account
                            </p>
                    }

                    <input style={styles.input} type="email" value={email} onChange={({ target: { value }}) => setEmail(value)} placeholder="Email" />
                    <input style={styles.input} type="password" value={password} onChange={({ target: { value }}) => setPassword(value)} placeholder="password" />
                    {signingUp && (
                        <>
                            <p style={{ ...styles.subTexts, marginBottom: 15 }}>
                                Personal Information
                            </p>
                            <input style={styles.input} value={fullnames} onChange={({ target: { value }}) => setFullNames(value)} placeholder="Fullnames" />
                            <input style={styles.input} value={phone} onChange={({ target: { value }}) => setPhone(value)} placeholder="Phone Number" />
                            <input style={styles.input} type="number" value={idNumber} onChange={({ target: { value }}) => setIdNumber(value)} placeholder="ID Number" />
                            <input style={styles.input} value={address} onChange={({ target: { value }}) => setAddress(value)} placeholder="Residence Address" />
                        </>
                    )}
                    {errors !== null && (
                        <p style={{ textAlign: "center", fontSize: 16, color: "red", marginHorizontal: 10 }}>{errors}</p>
                    )}
                    {!signingUp && errors === null && <div style={styles.forgotPassword}>
                        <p style={styles.forgotPasswordText}>Forgot Password</p>
                    </div>}
                    {signingUp ? (
                        <div style={styles.buttons}>
                            <div onClick={signinup} style={{ ...styles.buttonWrapper, backgroundColor: "red" }}>
                                <p style={{ ...styles.buttonText, color: "white" }}>Create Account</p>
                            </div>
                            <div  onClick={() => setSignUp(false)} style={{ ...styles.buttonWrapper, borderWidth: 1, borderColor: "red"  }}>
                                <p style={styles.buttonText}>Already Have An Account</p>
                            </div>
                        </div>
                    ) : (
                        <div style={styles.buttons}>
                            <div onClick={signingIn} style={{ ...styles.buttonWrapper, backgroundColor: "red"  }}>
                                <p style={{ ...styles.buttonText, color: "white" }}>Log In</p>
                            </div>
                            <div onClick={() => setSignUp(true)} style={{ ...styles.buttonWrapper, borderWidth: 1, borderColor: "red"  }}>
                                <p style={styles.buttonText}>Create An Account Instead</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {loading && (
                <div style={{ position: "absolute", width: "100vw", height: "100vh", top: 0, left: 0, backgroundColor: "rgba(0,0,0,0.7)" }}>
                    <p>Loading...</p>
                </div>
            )}
        </>
    )
}
